import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'

import { BeneficiarySoaSubmitDetail } from '../models/submit-soa-model'
import { SOAFormSubmissionGateWay } from '../gateways/soa-form-submission-gateways'
@Injectable()
export class NetworkSOAFormSubmissionGateway extends SOAFormSubmissionGateWay {
    constructor(private http: HttpClient) {
        super()
    }

    // TODO once methos in controller are defined , please call from here in order to return data from backend

    sendEmail(submitSoaModel: BeneficiarySoaSubmitDetail): Observable<boolean> {
        console.log('test network gatway')
        return this.http.post<boolean>('../api/InsertBeneficiarySOADetail', JSON.stringify(submitSoaModel))
    }
}
